import { formatNumber } from "@uicore";
import { useAppState } from "@/modules/app/useAppContext";
import styles from "../../../styles.module.scss";

interface MoneyCellProps {
  value: number;
}

export const MoneyCell = ({ value }: MoneyCellProps) => {
  const { currency } = useAppState();

  const getNumString = (num: number) => {
    const fractions = Number(num) < 1 && Number(num) > 0 ? 2 : 0;
    return formatNumber(num, {
      currency,
      minimumFractionDigits: fractions,
      maximumFractionDigits: fractions,
    });
  };

  return <div className={styles.moneySaving}>{getNumString(value)}</div>;
};
